import axiosApiInstance from "./middlewares";

export const methods = {
  POST: "POST",
  GET: "GET",
  PUT: "PUT",
  PATCH: "PATCH",
  DELETE: "DELETE",
};

export function getBaseUrl(version_number = "v1") {
  let BaseURL = process.env.REACT_APP_BASE_API_URL;
  return version_number === "v1"
    ? BaseURL
    : BaseURL.split("v1").join(version_number);
}

export function isDevelopmentMode() {
  return true;
}

export function sendRequest(
  url,
  method = methods.GET,
  params = null,
  config,
  version_number = "v1"
) {
  const baseUrl = getBaseUrl(version_number);
  if (method === methods.GET) {
    return axiosApiInstance.get(baseUrl + url);
  } else if (method === methods.POST) {
    return axiosApiInstance.post(baseUrl + url, params, config);
  } else if (method === methods.PUT) {
    return axiosApiInstance.put(baseUrl + url, params, config);
  } else if (method === methods.PATCH) {
    return axiosApiInstance.patch(baseUrl + url, params, config);
  }
}
